<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :visibleStore="false" :loading="loading" :filter="true" filterLabel="検索">
            <template v-slot:action="{ item }">
                <v-btn class="mr-2" depressed small color="warning" :to="{ name: 'ConstructionNumberFixEdit', params: { id: item.id } }">編集</v-btn>
            </template>
        </custom-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import ConstructionDepartmentApi from "@/api/construction-department-api"
  import CustomDataTable from "@/components/custom_ui/CustomDataTable"

  export default {
    name: "ConstructionNumberFix",
    components: {
      CustomDataTable
    },
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: データテーブル関連
      loading: false,
      tableName: '工番情報',
      headers: [
        { text: "工番", value: "construction_number" },
        { text: "工事名", value: "construction_name" },
        { text: "工期(自)", value: "start_date" },
        { text: "工期(至)", value: "end_date" },
        { text: "監督者", value: "management_user_name" },
        { text: "アクション", value: "action" }
      ],
      items: [],
    }),
    created () {
      this.initialize ()
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.searchDepartmentId = "0";
        this.constructionDepartmentApi = new ConstructionDepartmentApi();
        const promise = this.constructionDepartmentApi.list(this.searchDepartmentId);
        promise.then((response) => {
            for (var item of response.data.body.construction_department_list) {
                if (item.status != 0) {
                    this.items.push(item);
                }
            }
        }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
                if (error.response.data.status == statusList.status.authError) {
                this.$emit('logoutConform');
                } else if (error.response.data.status == statusList.status.entityError){
                this.$emit("error",error.response.data.message);
                this.$router.push({ name: "Dashboard" })
                } else {
                this.$emit("error",error.response.data.message);
                }
            } else {
                this.$emit("error","サーバーエラーが発生しました。");
            }
        }).finally(() => {
            this.isLoading();
        });
      }
    }
  }
</script>
